// extracted by mini-css-extract-plugin
module.exports = {"root":"HeaderRow_root__3bhcJ","pageTitle":"HeaderRow_pageTitle__3qDi_","pageSubTitle":"HeaderRow_pageSubTitle__2iB0E"};